import { render } from "./select-care-schedules.vue?vue&type=template&id=4839f552&scoped=true"
import script from "./select-care-schedules.vue?vue&type=script&lang=js"
export * from "./select-care-schedules.vue?vue&type=script&lang=js"

import "./select-care-schedules.vue?vue&type=style&index=0&id=4839f552&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4839f552"]])

export default __exports__